export const vendorMessageFieldName = 'vendorMessage';
